module.exports = __webpack_public_path__ + "img/more_black.ec1d84c4.svg";